import { useState } from "react";

import { EditIcon } from "@dotnet/telematics-design-system";

import { useDialog } from "../../ActionBar/hooks";
import { DEVICE_MODEL_ACTIONS } from "../../types";
import { TITLES } from "../constants";

const useCompatibilitiesInlineActions = () => {
    const { isOpenDialog, closeDialog, openDialog } = useDialog();

    const [rowData, setRowData] = useState(null);

    const openEditDialog = (data: any) => {
        setRowData(data);
        openDialog(DEVICE_MODEL_ACTIONS.EditCompatibility);
    };

    const closeCompatibilityEditDialog = () => {
        setRowData(null);
        closeDialog(DEVICE_MODEL_ACTIONS.EditCompatibility);
    };

    const inlineActions = [
        {
            title: TITLES.EditCompatibility,
            icon: EditIcon,
            clickAction: (data: any) => openEditDialog(data)
        }
    ];

    return {
        compatibilityInlineActions: inlineActions,
        compatibilityRowData: rowData,
        isEditCompatibilityOpen:
            isOpenDialog[DEVICE_MODEL_ACTIONS.EditCompatibility],
        closeCompatibilityEditDialog
    };
};

export { useCompatibilitiesInlineActions };
